<script setup lang="ts">
// 오류 로그 뷰어(개발용 부유 패널). 뱃지에 오류 수, 누르면 목록·복사·지우기.
import { ref } from 'vue'
import { errorState, clearErrors } from '../lib/errorLog'

const open = ref(false)
function copy() {
  const text = errorState.list.map(e => `[${e.t}] ${e.src}: ${e.msg}${e.stack ? '\n' + e.stack : ''}`).join('\n\n')
  navigator.clipboard?.writeText(text).catch(() => {})
}
</script>

<template>
  <div class="errlog">
    <button class="errlog-badge" :class="{ has: errorState.list.length }" @click="open = !open">오류 {{ errorState.list.length }}</button>
    <div v-if="open" class="errlog-panel">
      <div class="errlog-head">
        <b>오류 로그 ({{ errorState.list.length }})</b>
        <span><button @click="copy">복사</button><button @click="clearErrors">지우기</button><button @click="open = false">닫기</button></span>
      </div>
      <div v-if="!errorState.list.length" class="errlog-empty">오류 없음</div>
      <div v-for="(e, i) in [...errorState.list].reverse()" :key="i" class="errlog-item">
        <div class="errlog-meta"><b>{{ e.src }}</b> · {{ new Date(e.t).toLocaleTimeString() }}</div>
        <div class="errlog-msg">{{ e.msg }}</div>
        <pre v-if="e.stack">{{ e.stack }}</pre>
      </div>
    </div>
  </div>
</template>
